// extracted by mini-css-extract-plugin
export default {"container":"PasskeysSection_container__cS6jG","status":"PasskeysSection_status__w+5tt"};